/**
 * PostgREST (Supabase) corta cada respuesta en 1000 filas (max-rows del proyecto), aunque la
 * query no tenga .limit(). Para catálogos o tablas que pasan de eso hay que paginar con .range().
 *
 * Caso real: el catálogo contable tiene 1,302 cuentas que aceptan partidas; la póliza manual solo
 * veía las primeras 1000 (hasta 7011…) y rechazaba 706… como "no existe".
 *
 * Uso: const cuentas = await fetchAll<Cuenta>((from, to) =>
 *        supabase.from('cuenta_contable').select('codigo,nombre').order('codigo').range(from, to))
 * La query debe tener un .order() estable para que las páginas no se pisen.
 */
type Pagina<T> = PromiseLike<{ data: T[] | null; error: { message: string } | null }>

export async function fetchAll<T>(build: (from: number, to: number) => Pagina<T>, pageSize = 1000): Promise<T[]> {
  const out: T[] = []
  for (let from = 0; ; from += pageSize) {
    const { data, error } = await build(from, from + pageSize - 1)
    if (error) throw new Error(error.message)
    const rows = data ?? []
    out.push(...rows)
    if (rows.length < pageSize) return out
  }
}
